// src/actions/UserActions.js
import HttpClient from '../services/HttpClient';
import axios from 'axios';

const instancia = axios.create();
instancia.CancelToken = axios.CancelToken;
instancia.isCancel = axios.isCancel;

export const getUsuarioById = (id) => {
    return new Promise( (resolve, reject) => {
        HttpClient.get(`/api/usuario/account/${id}`)
        .then(response => {
            resolve(response);
        })
        .catch(error => {
            resolve(error.response);
        })
    });
}

export const loginUsuario = (usuario) => {
    console.log(usuario);
    return new Promise((resolve, reject) => {
        instancia.post("/api/usuario/login", usuario).then(response => {
            resolve(response);
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export const registrarUsuario = async (usuarioData) => {
    try {
        const response = await instancia.post("/api/usuario/registrar", usuarioData);
        return response;
    } catch (error) {
        console.error('Error en registrarUsuario:', error);
        if (error.response) {
            // Error de respuesta del servidor (ej: 400, 500)
            return error.response;
        } else if (error.request) {
            // Error de conexión (no se recibió respuesta)
            return {
                status: 503,
                data: { message: "No se pudo conectar al servidor" }
            };
        } else {
            // Otros errores (ej: configuración incorrecta)
            return {
                status: 500,
                data: { message: error.message || "Error al registrar el usuario" }
            };
        }
    }
}

export const obtenerRoles = () => {
    return new Promise((resolve, reject) => {
        instancia.get("/api/usuario/roles")
        .then(response => {
            resolve(response);
        })
        .catch(error => {
            console.log("error del api roles:", error);
            reject({
                message: error.message,
                response: error.response || null,
                code: error.code || 'UNKNOWN_ERROR'
            });
        });
    });
}

export const obtenerUsuariosPorEntidad = (entidadId) => {
    return new Promise((resolve, reject) => {
        instancia.get(`/api/usuario/por-entidad/${entidadId}`)
        .then(response => {
            resolve(response);
        })
        .catch(error => {
            console.log("error del api usuarios por entidad:", error);
            reject({
                message: error.message,
                response: error.response || null,
                code: error.code || 'UNKNOWN_ERROR'
            });
        });
    });
}